<div class="cdp-filter-btn" [hcPop]="timeRangeOptionsPop">
    <span class="icon-left icon-calendar"></span>
    <span class="cdp-filter-btn-selection">{{ selectedRangeLabel }}</span>
    <span class="icon-right icon-chev-down"></span>
</div>

<hc-pop #timeRangeOptionsPop [showArrow]="false" horizontalAlign="start">
    <div class="popover-inner">
        <hc-form-field [tight]="true"
            ><hc-radio-group [(ngModel)]="timeRangeForm">
                @for (option of timeRangeOptions; track $index) {
                    @if (option.isCustom) {
                        <div (click)="onCustomRadioClick(valInput)">
                            <hc-radio-button [tight]="true" [checked]="true" [value]="option.id">
                                <span class="relative-time-radio-inner"
                                    >{{ option.timeRange.direction === TimeRangeDirection.BeforeNow ? 'Last' : 'Next'
                                    }}<hc-form-field tight inline class="relative-time-input"
                                        ><input
                                            #valInput
                                            class="relative-time-val-input"
                                            hcInput
                                            type="number"
                                            [(ngModel)]="option.timeRange.value"
                                            (keydown.enter)="done(timeRangeOptionsPop)"
                                            (keyup)="validateInput(valInput, option.timeRange)"
                                            (click)="$event.stopPropagation()"
                                            min="1"
                                            [max]="getMaxForInterval(option.timeRange.interval)" /></hc-form-field
                                    >{{ getStrForInterval(option.timeRange.interval) }}</span
                                >
                            </hc-radio-button>
                        </div>
                    } @else {
                        <hc-radio-button [tight]="true" [value]="option.id">{{
                            option.timeRange.name
                        }}</hc-radio-button>
                    }
                }
            </hc-radio-group></hc-form-field
        >
        <div class="popover-footer">
            <button hc-button buttonStyle="primary" (click)="done(timeRangeOptionsPop)" size="sm">Done</button>
        </div>
    </div>
</hc-pop>
